import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { Store, select } from '@ngrx/store'
import { map, Observable } from 'rxjs'
import { AppState } from '.././../../../core/store/index'
import { CreditService } from '.././../../../api/credit/credit.service'
import { CreditCalculationStructure, CreditStructure } from '../../../model/credit-structure.model'
import { CreditPortfolio } from '../../../model/credit-portfolio.model'
import { selectCurrentPortfolio } from '../../../store/credit.selectors'

@Component({
  selector: 'app-credit-create-submission-dialog-container',
  templateUrl: './credit-create-submission-dialog.container.html',
})
export class CreditCreateSubmissionDialogContainerComponent implements OnInit {
  calculationStructure$: Observable<CreditCalculationStructure | undefined>
  currentPortfolio$: Observable<CreditPortfolio | undefined>
  constructor(
    private store: Store<AppState>,
    private creditService: CreditService,
    private dialogRef: MatDialogRef<CreditCreateSubmissionDialogContainerComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: CreditStructure,
  ) {}

  ngOnInit(): void {
    if (!this.data) {
      return
    }
    this.calculationStructure$ = this.creditService
      .getCalculationStructureById(this.data.credit_calculation_structure_id)
      .pipe(map((res) => res.data))
    this.currentPortfolio$ = this.store.pipe(select(selectCurrentPortfolio))
  }

  onClose(): void {
    this.dialogRef.close()
  }
}
